import { PulseBaseProvider } from '../../base-classes';

const _locationSearchUri = '/data/locations/v3/location';
const _locationSearchCacheKey = 'locationSearch';

const _myLocationUri = '/api/loc/v3/city/ipaddress/me';
const _myLocationCacheKey = 'myLocation';

export class LocationSearchProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_locationSearchCacheKey] = this.locationSearchSyncer.bind(this);
        this.storage.sync[_myLocationCacheKey] = this.getMyLocationSyncer.bind(this);
    }

    async locationSearchSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const queryParams = {
            ...syncParams.stdParameters,
            searchString: syncParams.searchString.replace('+', ' ').replace('\'', '&rsquo;'),
            maxResults: syncParams.maxResults,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _locationSearchUri, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async searchLocation(searchString, stdParameters, verbose, refresh = false, maxResults=10) {
        const syncParams = {
            searchString,
            verbose: !!verbose,
            refresh,
            maxResults
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_locationSearchCacheKey, id);
        }
        return await super.loadFromStorage(_locationSearchCacheKey, id, syncParams);
    }

    async getMyLocationSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose
        };

        return await super.syncData(syncParams.key, id, queryParams, _myLocationUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getUserLocationByIP(stdParameters, verbose, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_myLocationCacheKey, id);
        }
        return await super.loadFromStorage(_myLocationCacheKey, id, syncParams);
    }
}
